import { render } from "./TagList.vue?vue&type=template&id=cc3072ce&scoped=true"
import script from "./TagList.vue?vue&type=script&lang=js"
export * from "./TagList.vue?vue&type=script&lang=js"

import "./TagList.vue?vue&type=style&index=0&id=cc3072ce&scoped=true&lang=scss"
/* custom blocks */
import block0 from "@/locales/ru/components/tag-list.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FTagList.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/components/tag-list.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FTagList.vue&locale=en"
if (typeof block1 === 'function') block1(script)
import block2 from "./TagList.vue?vue&type=custom&index=2&blockType=i18n"
if (typeof block2 === 'function') block2(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc3072ce"]])

export default __exports__